module.exports = __webpack_public_path__ + "media/customizations/vistaatmontaine/logo-new-5b21224c3a83f85d0da38152cb6ccf26.png";